<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="addColumns"
    ></page-template>
  </div>
</template>
<script>
import pageTemplate from "@/components/template/pageTemplate";
import formDialog from "@/components/template/formDialog";
import api from "@/config/api";

export default {
  components: {
    formDialog,
    pageTemplate,
  },
  data() {
    return {
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {label: "编码", prop: "code", type: "input", ifFuzzy: true, placeholder: "请输入编码"},
          {label: "名称", prop: "name", type: "input", ifFuzzy: true, placeholder: "请输入名称"}
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: "添加",
          code: 'insert',
        },
        {
          label: "编辑",
          code: 'update',
          type: this.$utils.buttonType.tableOperate,
        },
        {
          label: "删除",
          code: 'delete',
          type: this.$utils.buttonType.tableOperate,
        },
        {
          label: "启用",
          code: 'enable',
          type: this.$utils.buttonType.tableOperate,
          filter: (data) => {
            return data.status == 20
          },
          callback: this.changeStatus
        },
        {
          label: "停用",
          code: 'disable',
          type: this.$utils.buttonType.tableOperate,
          filter: (data) => {
            return data.status == 10
          },
          callback: this.changeStatus
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {
            label: "编码",
            prop: "code",
            width: "120",
            align: "center"
          },
          {label: "名称", prop: "name", width: "120", align: "center"},
          {
            label: "状态",
            prop: "status",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus('sysPayMode.status')
          },
          {
            label: "类型",
            prop: "type",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus('sysPayMode.type')
          },
          {
            label: "添加日期",
            prop: "createDttm",
            width: "120",
            align: "center",
          }
        ],
        url: api.system.payMode
      },
      // 添加字段
      addColumns: {
        labelWidth: "120px",
        span: 12,
        columns: [
          {
            label: "编码",
            type: "input",
            prop: "code",
            rule: [
              {required: true, message: "请输入编码", trigger: "blur"},
              {
                min: 2,
                max: 15,
                message: "长度在 2 到 15 个字符",
                trigger: "blur"
              }
            ]
          },
          {
            label: "名称",
            type: "input",
            prop: "name",
            rule: [
              {required: true, message: "请输入名称", trigger: "blur"},
            ],
          },
          {
            label: "类型",
            type: "select",
            prop: "type",
            data: this.$utils.getCacheStatus('sysPayMode.type'),
          },
          {
            label: "状态",
            type: "select",
            prop: "status",
            data: this.$utils.getCacheStatus('sysPayMode.status'),
          }
        ],
        url: api.system.payMode
      },
    };
  },
  methods: {
    changeStatus(row) {
      row.status = row.status == 10 ? 20 : 10;
      this.$axios.fetchPut(api.system.payWay, row).then(data => {
        if (data.code == 200) {
          this.$notify({
            type: "success",
            title: '修改操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '修改成功!'});
        } else {
          this.$message({message: data.msg, type: 'error'});
        }
      }).catch((err) => {
        this.$notify({
          type: "error",
          title: '修改操作',
          message: '失败',
          showClose: false,
        });
        // this.$message({message: data.msg, type: '修改出错'});
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/system/pay/Way.vue